var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15255",
    "data-name": "Group 15255",
    transform: "translate(-63 -451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34081",
    "data-name": "Path 34081",
    d: "M81.3,457.8H68.7a.9.9,0,0,0-.9.9v10.8a.9.9,0,0,0,.9.9H81.3a.9.9,0,0,0,.9-.9V458.7A.9.9,0,0,0,81.3,457.8ZM68.7,456a2.7,2.7,0,0,0-2.7,2.7v10.8a2.7,2.7,0,0,0,2.7,2.7H81.3a2.7,2.7,0,0,0,2.7-2.7V458.7a2.7,2.7,0,0,0-2.7-2.7Z",
    transform: "translate(0 -0.2)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34082",
    "data-name": "Path 34082",
    d: "M73.6,464a.9.9,0,1,0,0,1.8h6.3a.9.9,0,1,0,0-1.8Zm-2.7,3.6a.9.9,0,1,0,0,1.8h5.4a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-0.4 -1)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34083",
    "data-name": "Path 34083",
    d: "M70.9,454a.9.9,0,0,0-.9.9v3.6a.9.9,0,0,0,1.8,0v-3.6A.9.9,0,0,0,70.9,454Zm9,0a.9.9,0,0,0-.9.9v3.6a.9.9,0,0,0,1.8,0v-3.6A.9.9,0,0,0,79.9,454Z",
    transform: "translate(-0.4 0)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.0947b654b1455583c17e082e2ce3edd1.svg";
export { ForwardRef as ReactComponent };